import { styled } from '@mui/material/styles';
import { List, Badge } from '@mui/material';

export const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: theme.palette.background.label_chip_green,
    color: theme.palette.text.label_chip_green,
    width: '2rem',
    height: '1rem',
    borderRadius: '0.25rem',
    fontFamily: theme.fonts.figtreeMedium,
    fontSize: '0.625rem',
    lineHeight: '1rem',
    letterSpacing: '0%',
    right: '1.875rem',
    top: '0.0625rem',
    pointerEvents: 'none',
  },
}));

const StyledNavList = styled(List, { shouldForwardProp: (prop) => prop !== 'expanded' })(({ theme, expanded }) => ({
  padding: '8px 0',

  a: {
    textDecoration: 'none',
  },

  '& .MuiListItemButton-root': {
    padding: 0,
    backgroundColor: 'unset',
    '& .MuiListItemText-primary': {
      maxWidth: '150px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
  },

  '& .MuiListItem-root': {
    '&:hover': {
      backgroundColor: theme.palette.grey.bt_alt_grey_light,
      borderLeft: `4px solid ${theme.palette.generic.sysaid}`,
    },

    '& .MuiListItemButton-root': {
      marginRight: expanded && '-20px',

      '&:hover': {
        marginLeft: '-4px',
        borderRadius: !expanded && '0 4px 4px 0',
      },

      '& .MuiListItemIcon-root': {
        minWidth: '24px',
        padding: expanded ? '12px 12px 12px 24px' : '12px 16px',

        '.new-badge-circle': {
          position: 'absolute',
          top: '12px',
          right: '12px',
          width: '8px',
          height: '8px',
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='8' height='8' viewBox='0 0 8 8' fill='%2316A190' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.25 4C7.25 4.64279 7.05939 5.27114 6.70228 5.8056C6.34516 6.34006 5.83758 6.75662 5.24372 7.00261C4.64986 7.24859 3.9964 7.31295 3.36596 7.18755C2.73552 7.06215 2.15643 6.75262 1.7019 6.2981C1.24738 5.84358 0.937851 5.26448 0.812449 4.63404C0.687047 4.00361 0.751408 3.35014 0.997393 2.75628C1.24338 2.16242 1.65994 1.65484 2.1944 1.29772C2.72886 0.940609 3.35721 0.75 4 0.75C4.86163 0.751075 5.68765 1.09383 6.29691 1.70309C6.90617 2.31235 7.24893 3.13838 7.25 4Z' /%3E%3C/svg%3E%0A");`,
          transform: 'translate(-50%, 0%)',
        },
      },

      '& .MuiListItemText-root': {
        margin: 0,
        padding: '14px 0',
      },

      '& .MuiTypography-root': {
        fontStyle: 'normal',
        fontSize: '14px',
        lineHeight: '20px',
        color: theme.palette.text.title_txt,
        letterSpacing: 0,
      },
    },

    width: expanded && '220px',
    borderRadius: expanded && '0px 30px 30px 0px',
  },
  '& .active': {
    backgroundColor: theme.palette.grey.bt_alt_grey_light,
    borderLeft: `4px solid ${theme.palette.generic.sysaid}`,
    '&:hover': {
      backgroundColor: theme.palette.background.selected_and_hover,
      borderLeft: `4px solid ${theme.palette.generic.sysaid}`,
    },
    '& .MuiListItemButton-root': {
      marginLeft: '-4px',
    },
  },

  '&.userOptions .user': {
    '& .MuiListItemIcon-root': {
      padding: '6px 6px 6px 18px',
    },

    '& .MuiListItemText-root': {
      paddingTop: '10px',
      paddingBottom: '10px',

      '& .MuiTypography-root': {
        lineHeight: '16px',
      },
    },
  },
  '&.userOptions .user .MuiListItemIcon-root': {
    padding: !expanded && '6px 10px',
  },

  '& :not(.user) > .MuiListItemButton-root .MuiListItemIcon-root span': {
    height: '24px',
  },
}));

export default StyledNavList;
